import React from 'react';
import { PWAInstallDialog } from '@/components/PWAInstallDialog';

interface PWAWrapperProps {
  children: React.ReactNode;
}

export const PWAWrapper: React.FC<PWAWrapperProps> = ({ children }) => {
  return (
    <>
      {children}
      <PWAInstallDialog />
    </>
  );
};
